import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        © 2023 Sample Lab | Made with Love and ChatGPT. Imagined by{' '}
        <a
          href="https://twitter.com/ajjuism"
          target="_blank"
          rel="noopener noreferrer"
          className="twitter-link"
        >
          @ajjuism
        </a>
      </p>
    </footer>
  );
}

export default Footer;